__turbopack_context__.v({
  "AgencyHeroImageFormSection": "AgencyTeamHeroSection-module-scss-module___sSYOq__AgencyHeroImageFormSection",
  "AgencyHeroimageColTextForm": "AgencyTeamHeroSection-module-scss-module___sSYOq__AgencyHeroimageColTextForm",
  "AgencyHeroimageColTextForm--imageSmallDesign": "AgencyTeamHeroSection-module-scss-module___sSYOq__AgencyHeroimageColTextForm--imageSmallDesign",
  "AgencyHeroimageColTextForm--imageWithFormHeading": "AgencyTeamHeroSection-module-scss-module___sSYOq__AgencyHeroimageColTextForm--imageWithFormHeading",
  "formHeading": "AgencyTeamHeroSection-module-scss-module___sSYOq__formHeading",
  "formTagline": "AgencyTeamHeroSection-module-scss-module___sSYOq__formTagline",
  "imageSection": "AgencyTeamHeroSection-module-scss-module___sSYOq__imageSection",
  "textSection": "AgencyTeamHeroSection-module-scss-module___sSYOq__textSection",
});
